import React, { ReactNode } from 'react'

import * as S from './styles'

export interface RadioOption {
  id: string
  label: string
}

interface RadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean
  label: ReactNode
}

export function CustomRadioButton({
  label,
  hasError,
  value,
  id,
  ...input
}: RadioButtonProps): JSX.Element {
  return (
    <S.RadioButtonContainer hasError={hasError}>
      <input {...input} id={id} type='radio' value={value} checked={value === id}/>
      <label htmlFor={id}>{label}</label>
    </S.RadioButtonContainer>
  )
}
